import React from 'react';
import { Check } from 'lucide-react';
const base = ['5 Tomos completos (+150 páginas)', 'Bono 1 — Kit de Arranque Rápido', 'Bono 2 — Guía Anti-Frustración', 'Bono 3 — Checklist de Progreso'];
const premium = ['100 Flashcards de Palabras Frecuentes', '30 Misiones de Lectura Graduada', 'Guía SOS de Rescate Emocional', '4 Juegos con Flashcards', 'Preguntas de comprensión por misión'];
export function WhatsIncluded() {
  const rows = Math.max(base.length, premium.length);
  return <section className="py-12 md:py-16 bg-white" data-id="element-333">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-334">
        <div className="text-center mb-8" data-id="element-335">
          <h2 className="text-2xl font-bold text-navy flex items-center justify-center gap-2" data-id="element-336">
            <Check className="w-6 h-6 text-emerald-500" data-id="element-337" />
            ¿QUÉ INCLUYE CADA UNO?
          </h2>
        </div>

        <div className="rounded-3xl border border-slate-100 overflow-hidden shadow-sm" data-id="element-338">
          <table className="w-full table-fixed border-collapse" data-id="element-339">
            <thead data-id="element-340">
              <tr data-id="element-341">
                <th className="w-1/2 bg-blue-50 border-b border-blue-100/70 px-3 py-4 sm:px-5 text-center" data-id="element-342">
                  <span className="text-xs sm:text-base font-bold text-blue-700" data-id="element-343">
                    📘 MEGAPACK LECTURA FLUIDA
                  </span>
                </th>
                <th className="w-1/2 bg-gold/10 border-b border-l border-gold/20 px-3 py-4 sm:px-5 text-center" data-id="element-344">
                  <span className="text-xs sm:text-base font-bold text-gold-600 block" data-id="element-345">
                    ⚡ KIT ACELERADOR
                  </span>
                  <span className="text-[10px] sm:text-xs font-normal text-slate-500" data-id="element-346">
                    Solo en versión Premium
                  </span>
                </th>
              </tr>
            </thead>
            <tbody data-id="element-347">
              {Array.from({
              length: rows
            }).map((_, i) => <tr key={i} className="align-top" data-id="element-348">
                  <td className="bg-blue-50/30 border-b border-blue-100/40 px-3 py-3 sm:px-5 sm:py-4" data-id="element-349">
                    {base[i] && <div className="flex items-start gap-2" data-id="element-350">
                        <Check className="w-4 h-4 sm:w-5 sm:h-5 text-emerald-500 flex-shrink-0 mt-0.5" data-id="element-351" />
                        <span className="text-xs sm:text-base text-slate-700 leading-snug" data-id="element-352">
                          {base[i]}
                        </span>
                      </div>}
                  </td>
                  <td className="bg-gold/[0.04] border-b border-l border-gold/10 px-3 py-3 sm:px-5 sm:py-4" data-id="element-353">
                    {premium[i] && <div className="flex items-start gap-2" data-id="element-354">
                        <Check className="w-4 h-4 sm:w-5 sm:h-5 text-gold flex-shrink-0 mt-0.5" data-id="element-355" />
                        <span className="text-xs sm:text-base text-slate-700 leading-snug" data-id="element-356">
                          {premium[i]}
                        </span>
                      </div>}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}